import { ParticipantSession } from 'typings/participant_activity';
import { CandidateScore, TargetGroupCsvDataRow } from '../../../typings/user';
import {
    isCultureFitCandidateScore,
    isInterviewCandidateScore,
    isMentalTestCandidateScore,
} from '../utils';
import {
    CultureFitCategory,
    MentalTestCategory,
} from '@neurolytics/results-template';

const formatScore = (score: number | undefined): number | 'N/A' => {
    if (score || score === 0) {
        return Math.round(score);
    }
    return 'N/A';
};

const getCategoryScore = (score: any, scoreCategory: string) => {
    return score.categories && score.categories.length
        ? score.categories.filter(
              (category: CultureFitCategory | MentalTestCategory) =>
                  category.id === scoreCategory,
          )[0].candidate_score
        : 'NaN';
};

export function formatScores(
    scores: CandidateScore[],
    data: TargetGroupCsvDataRow,
) {
    const cultureFitScores = scores.find(isCultureFitCandidateScore);
    const interviewScores = scores.find(isInterviewCandidateScore);
    const mentalScores = scores.find(isMentalTestCandidateScore);

    if (!!cultureFitScores) {
        const cultureFitData = cultureFitScores.data.culture_fit;
        if (cultureFitData) {
            data.Engagement = formatScore(cultureFitData.company_engagement);
            data['Culture Match'] = formatScore(cultureFitData.culture_match);
            data.Family = formatScore(
                getCategoryScore(cultureFitData, 'family'),
            );
            data.Adhocracy = formatScore(
                getCategoryScore(cultureFitData, 'adhocracy'),
            );
            data.Market = formatScore(
                getCategoryScore(cultureFitData, 'market'),
            );
            data.Hierarchy = formatScore(
                getCategoryScore(cultureFitData, 'hierarchy'),
            );
        }
    }

    if (!!interviewScores) {
        const interviewData = interviewScores.data.interview;
        if (interviewData) {
            data.Motivation = formatScore(interviewData.work_motivation);
            data.Confidence = formatScore(interviewData.confidence);
        }
    }

    if (!!mentalScores) {
        const mentalTestData = mentalScores.data.mental_test;

        if (mentalTestData) {
            data['Stress resilience'] = formatScore(
                mentalTestData.stress_resilience,
            );
            data['Ease under pressure'] = formatScore(mentalTestData.ease);
            // ak = general knowledge ('algemene kennis')
            data['General knowledge'] = formatScore(
                getCategoryScore(mentalTestData, 'ak'),
            );
            // lr = logical reasoning ('logisch redeneren')
            data['Logical reasoning'] = formatScore(
                getCategoryScore(mentalTestData, 'lr'),
            );
            // nr = numerical reasoning ('numeriek redeneren')
            data['Numerical reasoning'] = formatScore(
                getCategoryScore(mentalTestData, 'nr'),
            );
            // vr = verbal reasoning ('verbaal redeneren')
            data['Verbal reasoning'] = formatScore(
                getCategoryScore(mentalTestData, 'vr'),
            );
        }
    }
}

export function formatSession(
    sessions: ParticipantSession[],
    data: TargetGroupCsvDataRow,
) {
    const millisToMinutesAndSeconds = (millis: number) => {
        let minutes = Math.floor(millis / 60000);
        let seconds = parseInt(((millis % 60000) / 1000).toFixed(0));
        return seconds === 60
            ? minutes + 1 + ':00'
            : minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    };

    if (sessions && sessions.length && sessions[0]) {
        data['Date completed'] = sessions[0].finishedAt;
        data.OS = `${sessions[0].device.os.name} ${sessions[0].device.os.version}`;
        data.Browser = sessions[0].browser.name;
        data['Total time to complete scan'] = `${
            sessions[0].totalTime
                ? millisToMinutesAndSeconds(sessions[0].totalTime)
                : null
        }`;
    }
}
